import { ordersDB, productsDB, categoriesDB, tablesDB } from "../db";
async function saveToDB(db: PouchDB.Database, data: any) {
  try {
    const response = await db.put({
      _id: new Date().toISOString(),
      ...data,
      synced: false
    });
    console.log("Saved locally:", response);
  } catch (error) {
    console.error("Error saving data:", error);
  }
}


async function getUnsyncedData(db: PouchDB.Database) {
  const result = await db.allDocs({ include_docs: true });
  return result.rows.map((row) => row.doc).filter((doc:any) => !doc.synced);
}


async function getAllData(db: PouchDB.Database) {
  const result = await db.allDocs({ include_docs: true });
  return result.rows.map((row) => row.doc);
}


async function syncData(db: PouchDB.Database, apiEndpoint: string) {
  const unsyncedData = await getUnsyncedData(db);
  if (unsyncedData.length > 0) {
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(unsyncedData),
      });

      if (response.ok) {
        //marking data as synced in PouchDB
        for (const item of unsyncedData) {
          await db.put({ ...item, synced: true });
        }
        console.log(`Synced ${unsyncedData.length} items to ${apiEndpoint}`);
      }
    } catch (error) {
      console.error("Sync failed:", error);
    }
  }
}

//saving different types of data
export const saveOrder = (order: any) => saveToDB(ordersDB, order);
export const saveProduct = (product: any) => saveToDB(productsDB, product);
export const saveCategory = (category: any) => saveToDB(categoriesDB, category);
export const saveTable = (table: any) => saveToDB(tablesDB, table);

//get data
export const getOrders = () => getAllData(ordersDB);
export const getProducts = () => getAllData(productsDB);
export const getCategories = () => getAllData(categoriesDB);
export const getTables = () => getAllData(tablesDB);

//syncing data
export const syncOrders = () => syncData(ordersDB, "/api/sync-orders");
export const syncProducts = () => syncData(productsDB, "/api/sync-products");
export const syncCategories = () => syncData(categoriesDB, "/api/sync-categories");
export const syncTables = () => syncData(tablesDB, "/api/sync-tables");



async function upsertServerData(db: PouchDB.Database, serverData: any[]) {
  try {
    const keys = serverData.map(item => item.id.toString());
    const existingDocs = await db.allDocs({ keys, include_docs: true }) as any;

    const docsToUpsert = serverData.map(item => {
      const existingDoc = existingDocs.rows.find((row:any) => row.id === item.id.toString())?.doc;
      return {
        _id: item.id.toString(),
        _rev: existingDoc?._rev, 
        ...item,
        synced: true
      };
    });

    const result = await db.bulkDocs(docsToUpsert);
    const errors = result.filter(r => 'error' in r);
    if (errors.length > 0) {
      console.error('Some documents failed to upsert:', errors);
    }
  } catch (error) {
    console.error('Error upserting server data:', error);
  }
}
export const upsertServerProducts = (products: any[]) => upsertServerData(productsDB, products);
export const upsertServerCategories = (categories: any[]) => upsertServerData(categoriesDB, categories);
